/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useState } from "react";
import SearchFilter from "components/search-filter-list/search-filter-list";
import ListGallery from "components/webpage-selector/gallery/list_gallery";
import GalleryContext from "components/webpage-selector/gallery/context";
import { useMountedState } from "react-use";
// import { Logger } from "cms/utils/log/logger";

const WebpageDialogGalleryPanel = () => {

    const [needsRefresh, setNeedsRefresh] = useState(false);
    const mounted = useMountedState();
    const galleryCtx = useContext(GalleryContext);
    const webpages = galleryCtx?.webpages ?? [];
    const setWebpages = galleryCtx?.setWebpages;
    const searchFunction = galleryCtx?.searchFunction;
    const filter = galleryCtx?.filter;
    const filterValue = galleryCtx?.filterValue;
    
    return (
        <Fragment>
            <div className='simplicity-image-selector-window-content-gallery'>
                <SearchFilter
                    items={webpages}
                    setItems={setWebpages}
                    autoLoad={true}
                    searchFunction={searchFunction}
                    needsRefresh={needsRefresh}
                    setNeedsRefresh={setNeedsRefresh}
                    filter={filter}
                    filterValue={filterValue}
                    instruction={"Select from existing webpages"}
                    mounted={mounted}
                >
                    <ListGallery />
                </SearchFilter>
            </div>
        </Fragment>
    );
};

export { WebpageDialogGalleryPanel };
